import DOMPurify from 'dompurify';
import katex from 'katex';

/**
 * Re-renders each Quill formula (.ql-formula) into an HTML string,
 * using the original LaTeX saved in data-value...
 * @param {string} html - Saved HTML that can contain .ql-formula nodes
 * @returns {string} HTML with each formula re-rendered from its LaTeX
 */
const reRenderFormulas = (html) => {
  if (!html) return html;

  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('.ql-formula').forEach((node) => {
      const latex = node.getAttribute('data-value');
      if (!latex) return;

      try {
        node.innerHTML = katex.renderToString(latex, { throwOnError: false });
      } catch (e) {
        // A broken formula shouldn't break the whole view
      }
    });

    return doc.body.innerHTML;
  } catch (e) {
    return html;
  }
};

export const sanitizeRichText = (html) =>
  DOMPurify.sanitize(reRenderFormulas(html));
